/* eslint-disable prettier/prettier */
import axios from 'axios';

export const GetProductsAndStore = async (divcode, dbTokenData, loginUrl) => {
  try {
    const authHeaders = {
      Authorization: `Bearer ${dbTokenData}`,
      'Content-Type': 'application/json',
      dbMaster: ''
    };
    const productStockRes = await axios.get(`${loginUrl}product_stock/search?userid=Admin&ptypes=1,2,3,4&divcode=${divcode}`, {
      headers: authHeaders
    });
    localStorage.setItem('productsData', JSON.stringify(productStockRes.data));
    return true;
  } catch (e) {
    console.error('Error:', e);
    return false;
  }
};

export const GetAllProductsAndStore = async () => {
  try {
    const storedData = localStorage.getItem('productsData');

    if (storedData) {
      localStorage.setItem('allProductsData', storedData);
      return true;
    } else {
      console.error('No product data found in localStorage.');
      return false;
    }
  } catch (e) {
    console.error('Error reading product data from localStorage:', e);
    return false;
  }
};
